import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import FigmaBadge from '../Elements/FigmaBadge';
import UserNameComponent from '../Elements/UserNameComponent';

export default class CountryItemForAdmin {
  constructor(item) {
    if (item === undefined) {
      this.CountryId = '';
      this.Name = '';
      this.Code = '';
      this.Idc = '';
      this.IsActive = '';
      this.OfficeId = '';
      this.OfficeName = '';
      this.EvaluatorOfficeId = '';
      this.EvaluatorOfficeName = '';
      this.EvaluatorCurrencyId = '';
      this.EvaluatorCurrencyName = '';
      this.LocalCurrencyId = '';
      this.LocalCurrencyName = '';
      this.ClientBillingCurrencyId = '';
      this.ClientBillingCurrencyName = '';
      this.ClientFeeCurrencyId = '';
      this.ClientFeeCurrency = '';
      this.DefaultSchedulerUserId = '';
      return;
    }
    this.CountryId = item.countryId;
    this.Name = item.name;
    this.Code = item.code;
    this.Idc = item.idc;
    this.IsActive = item.isActive === true;
    this.OfficeId = item.officeId;
    this.OfficeName = item.officeName;
    this.EvaluatorOfficeId = item.evaluatorOfficeId;
    this.EvaluatorOfficeName = item.evaluatorOfficeName;
    this.EvaluatorCurrencyId = item.evaluatorCurrencyId;
    this.EvaluatorCurrencyName = item.evaluatorCurrencyName;
    this.LocalCurrencyId = item.localCurrencyId;
    this.LocalCurrencyName = item.localCurrencyName;
    this.ClientBillingCurrencyId = item.clientBillingCurrencyId;
    this.ClientBillingCurrencyName = item.clientBillingCurrencyName;
    this.ClientFeeCurrencyId = item.clientFeeCurrencyId;
    this.ClientFeeCurrency = item.clientFeeCurrency;
    this.DefaultSchedulerUserId = item.defaultSchedulerUserId;
  }

  static BoolFields = ['ShowFulfillmentDate'];
  static DateFields = ['TipaltiFromDate'];
  static MoneyFields = [];
  static MoneyFieldsSecondary = [];

  static NameOfTheIdField() {
    return 'CountryId';
  }

  static nameOfTheItemDetailList() {
    return 'Country';
  }

  static clickOnDownloadInXLSIcon() {
    alert('clickOnApproveInvoiceImageIcon');
  }

  static Currency() {
    return '';
  }
  static CurrencySecondary() {
    return '';
  }

  static editFunction = (id, country, countryList) => {
    alert('editFunction');
  };

  static FieldsToShowInListTable = [];

  static GetDefaultScheduler(item) {
    if (!item.DefaultSchedulerUserId) return null;
    return <UserNameComponent userId={item.DefaultSchedulerUserId} />;
  }

  static GetStatus(item) {
    // if(!item) return null;
    return item.IsActive === true ? <FigmaBadge Active={true} /> : <FigmaBadge Active={false} />;
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Country Id', orderById: 'CountryId', data: 'CountryId', width: TabListTableCellWidthEnum.Table },
      { label: 'Country Name', orderById: 'Name', data: 'Name', width: TabListTableCellWidthEnum.Table },
      { label: 'Code', orderById: 'Code', data: 'Code', width: TabListTableCellWidthEnum.Table },
      {
        label: 'Sales/FW Office',
        orderById: 'OfficeName',
        data: 'OfficeName',
        width: TabListTableCellWidthEnum.Table,
        tableminWidth: '150px',
      },
      {
        label: 'Client Fee Currency',
        orderById: 'ClientFeeCurrency',
        data: 'ClientFeeCurrency',
        minWidth: 150,
        width: TabListTableCellWidthEnum.Table,
      },
      {
        label: 'Evaluator Payment Office',
        orderById: 'EvaluatorOfficeName',
        data: 'EvaluatorOfficeName',
        minWidth: 150,
        width: TabListTableCellWidthEnum.Table,
        tableminWidth: '170px',
      },
      {
        label: 'Evaluator Fee Currency',
        orderById: 'EvaluatorCurrencyName',
        data: 'EvaluatorCurrencyName',
        minWidth: 145,
        width: TabListTableCellWidthEnum.Table,
        tableminWidth: '170px',
      },
      {
        label: 'Reimbursement Currency',
        orderById: 'LocalCurrencyName',
        data: 'LocalCurrencyName',
        minWidth: 150,
        width: TabListTableCellWidthEnum.Table,
        tableminWidth: '170px',
      },
      { label: 'Idc', orderById: '', data: 'IDC', width: TabListTableCellWidthEnum.Table },
      {
        label: 'Default Scheduler',
        orderById: '',
        data: CountryItemForAdmin.GetDefaultScheduler,
        minWidth: 150,
        width: TabListTableCellWidthEnum.Table,
        tableminWidth: '150px',
      },

      { label: 'Status', orderById: '', data: CountryItemForAdmin.GetStatus, minWidth: 20 },
      {
        label: 'Actions',
        orderById: '',
        data: CountryItemForAdmin.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            onClick: () => CountryItemForAdmin.editFunction(item.CountryId, item),
            iconName: 'fa-solid fa-edit',
            roleKey: 'countryEdit',
          },
        ]}
      />
    );
  }
}
